var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubtract = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM5.0466 8.13754L6.73667 9.5628L11.2372 5.01799C11.4239 4.82946 11.7278 4.82705 11.9174 5.01259C12.1087 5.19971 12.1112 5.50676 11.9229 5.69693L7.2022 10.4655C6.97318 10.6968 6.60494 10.7136 6.35579 10.5041L4.42263 8.8785C4.21811 8.70652 4.19152 8.4014 4.3632 8.19663C4.5354 7.99122 4.8417 7.96474 5.0466 8.13754Z",
    fill: "#4E4E4E",
    fillOpacity: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubtract);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Subtract.b52ae05013c6c1c1225a5b970111fb85.svg";